module.exports = __webpack_public_path__ + "img/4-TEVELAVE-min.5bf94bc3.jpg";